import { InfiniteScrollTable } from '@/ui/table/infinite-table/infinite-scroll-table';
import { usePendingCompanies } from '../../pending-companies/use-pending-companies.query';
import { projectListingSortState } from '../../project-listing.state';
import { usePendingProjectsTableConfig } from './use-pending-projects-table-config';
import { PendingProjectsEmptyState } from './pending-projects-empty-state';
import type { FetchNextPageOptions } from '@tanstack/react-query';

interface PendingProjectsTableProps {
  isDisabledMode?: boolean;
}

export const PendingProjectsTable = ({
  isDisabledMode,
}: PendingProjectsTableProps = {}) => {
  const { pendingCompanies, isLoading, hasNextPage, fetchNextPage } =
    usePendingCompanies({
      enabled: !isDisabledMode,
    });

  const { headers, rows } = usePendingProjectsTableConfig(pendingCompanies);

  const tableHeight = pendingCompanies.length > 6 ? '800px' : '400px';
  const isEmpty = !isLoading && pendingCompanies.length === 0;

  if (isDisabledMode) {
    return null;
  }

  if (isEmpty) {
    return <PendingProjectsEmptyState />;
  }

  return (
    <InfiniteScrollTable
      id="pending-projects-table"
      dataTestId="pending-projects-table"
      sortState={projectListingSortState}
      data={pendingCompanies}
      rows={rows}
      headers={headers}
      isLoading={isLoading}
      onLoadMore={(options?: FetchNextPageOptions) => fetchNextPage(options)}
      hasMore={hasNextPage ?? false}
      height={tableHeight}
      tableShadow
      tableBorderRadius="8px"
    />
  );
};
